import api from '@/api';

const { $academic } = api;

export const { $sectionLms, $terms } = $academic

